// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/fonts/Poppins-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("assets/fonts/Poppins-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/Poppins-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/Poppins-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/Poppins-SemiBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/Poppins-Bold.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: 'Poppins';
  font-weight: 100;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('truetype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('truetype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('truetype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('truetype');
}
@font-face {
  font-family: 'Poppins';
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('truetype');
}
* {
  font-family: 'Poppins', sans-serif;
  font-weight: 300;
  letter-spacing: -0.04em;
  outline: none;
}
:root {
  --primary-color: #003930;
  --primary-text-color: white;
  --primary-button-color: #0BB599;
  --primary-button-text-color: #003930;
  --secondary-button-color: #B5E8E0;
  --secondary-button-text-color: black;
  --link-button-color: black;
  --avatar-text-color: #ffffff;
  --success-color: #5CC827;
  --success-light-color: #E0F8F4;
  --warning-color: #F3A712;
  --warning-light-color: #FFF6ED;
  --more-warning-color: #e65100;
  --danger-color: #F45153;
  --danger-light-color: #FFEDED;
  --antd-wave-shadow-color: var(--primary-button-color);
  --xxl-content-padding: 2rem 3.75rem;
  --xl-content-padding: 2rem 3.75rem;
  --md-content-padding: 1rem;
}
html {
  overflow-x: hidden;
  scroll-behavior: smooth;
}
html .desktop-only {
  display: block !important;
}
html .mobile-only {
  display: none !important;
}
@media (max-width: 768px) {
  html .desktop-only {
    display: none !important;
  }
  html .mobile-only {
    display: block !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/sdk.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,gBAAA;EACA,+DAAA;AACF;AAEA;EACE,sBAAA;EACA,gBAAA;EACA,+DAAA;AAAF;AAGA;EACE,sBAAA;EACA,gBAAA;EACA,+DAAA;AADF;AAIA;EACE,sBAAA;EACA,gBAAA;EACA,+DAAA;AAFF;AAKA;EACE,sBAAA;EACA,gBAAA;EACA,+DAAA;AAHF;AAMA;EACE,sBAAA;EACA,gBAAA;EACA,+DAAA;AAJF;AAOA;EACE,kCAAA;EACA,gBAAA;EACA,uBAAA;EACA,aAAA;AALF;AAQA;EAEE,wBAAA;EACA,2BAAA;EAEA,+BAAA;EACA,oCAAA;EAEA,iCAAA;EACA,oCAAA;EAEA,0BAAA;EACA,4BAAA;EAEA,wBAAA;EACA,8BAAA;EAEA,wBAAA;EACA,8BAAA;EAEA,6BAAA;EAEA,uBAAA;EACA,6BAAA;EAEA,qDAAA;EAGA,mCAAA;EACA,kCAAA;EACA,0BAAA;AAjBF;AAoBA;EACE,kBAAA;EACA,uBAAA;AAlBF;AAgBA;EAIkB,yBAAA;AAjBlB;AAaA;EAKiB,wBAAA;AAfjB;AAgBE;EAAA;IACkB,wBAAA;EAblB;EAYA;IAEiB,yBAAA;EAXjB;AACF","sourcesContent":["@font-face {\n  font-family: 'Poppins';\n  font-weight: 100;\n  src: url(\"assets/fonts/Poppins-ExtraLight.ttf\") format('truetype');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 300;\n  src: url(\"assets/fonts/Poppins-Light.ttf\") format('truetype');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 400;\n  src: url(\"assets/fonts/Poppins-Regular.ttf\") format('truetype');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 500;\n  src: url(\"assets/fonts/Poppins-Medium.ttf\") format('truetype');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 600;\n  src: url(\"assets/fonts/Poppins-SemiBold.ttf\") format('truetype');\n}\n\n@font-face {\n  font-family: 'Poppins';\n  font-weight: 700;\n  src: url(\"assets/fonts/Poppins-Bold.ttf\") format('truetype');\n}\n\n* {\n  font-family: 'Poppins', sans-serif;\n  font-weight: 300;\n  letter-spacing: -0.04em;\n  outline: none;\n}\n\n:root {\n  // Cores padrões\n  --primary-color: #003930;\n  --primary-text-color: white;\n  \n  --primary-button-color: #0BB599;\n  --primary-button-text-color: #003930;\n  \n  --secondary-button-color: #B5E8E0;\n  --secondary-button-text-color: black;\n  \n  --link-button-color: black;\n  --avatar-text-color: #ffffff;\n  \n  --success-color: #5CC827;\n  --success-light-color: #E0F8F4;\n\n  --warning-color: #F3A712;\n  --warning-light-color: #FFF6ED;\n\n  --more-warning-color: #e65100;\n\n  --danger-color: #F45153;\n  --danger-light-color: #FFEDED;\n\n  --antd-wave-shadow-color: var(--primary-button-color);\n\n  // Padding padrão dos conteúdos\n  --xxl-content-padding: 2rem 3.75rem;\n  --xl-content-padding: 2rem 3.75rem;\n  --md-content-padding: 1rem;\n}\n\nhtml {\n  overflow-x: hidden;\n  scroll-behavior: smooth;\n\n  .desktop-only { display: block !important; }\n  .mobile-only { display: none !important; }\n  @media(max-width: @md-screen) {\n    .desktop-only { display: none !important; }\n    .mobile-only { display: block !important; }\n  }\n}\n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
